import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { TagEvent } from 'tag/ts/tag/events/TagEvent';
export class AbstractAviaPlayerHook extends AbstractTagClass {
    constructor(argument) {
        super(argument);
    }
    registerHook = () => {
        this.dispatchTagEvent(this.getTagEventVO(TagEvent.ON_PLAYER_HOOK_REQUEST_REGISTER, this.tag, {
            playerHookRequestRegister: {
                hook: this
            }
        }, this));
    };
    removeHook = () => {
        this.dispatchTagEvent(this.getTagEventVO(TagEvent.ON_PLAYER_HOOK_REQUEST_REMOVE, this.tag, {
            playerHookRequestRemove: {
                hook: this
            }
        }, this));
    };
    cleanUp = () => {
        this.removeHook();
    };
}
